import React from 'react';
import { ReactComponent as Select } from '../../../assets/svg/select.svg'
import { ReactComponent as Flowww } from '../../../assets/svg/flowww.svg'
import './Footer.scss'


function Footer() {
  return (
    <section className="footer">
      <div className='container'>
        {/* <Select /> */}
        <Flowww />
      </div>
    </section>
  );
}

export default Footer;